export default "__VITE_ASSET__CHBJuSNB__"